import { render, staticRenderFns } from "./ClientSettingAssignToNode.vue?vue&type=template&id=1b01d534&scoped=true"
import script from "./ClientSettingAssignToNode.vue?vue&type=script&lang=js"
export * from "./ClientSettingAssignToNode.vue?vue&type=script&lang=js"
import style0 from "./ClientSettingAssignToNode.vue?vue&type=style&index=0&id=1b01d534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b01d534",
  null
  
)

export default component.exports